import React from 'react'
import Navigation from './Navigation'

// Styled Components
import { Header, TitleWrap, Title, Subtitle } from './Header.styles'

const HeaderComponent = () => (
    <Header>
        <TitleWrap to="/">
            <Title>mathbox</Title>
            <Subtitle>beta</Subtitle>
        </TitleWrap>
        <Navigation />
    </Header>
)

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/Header.js